import { action } from 'typesafe-actions';

export const register = data => action('@register/REGISTER', data);
